export const blockIconsHomeNestRemoteNew = (
	<span className='material-symbols-outlined'>nest_remote</span>
);
